var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hero',{attrs:{"title":"403","subtitle":"Accesso Negato","text":"Scusaci! Non sei autorizzato ad accedere a questa pagina."}})}
var staticRenderFns = []

export { render, staticRenderFns }